import { AutocompleteItem, Card, CardBody, Button, Input, Select, SelectItem, Autocomplete, Chip } from "@heroui/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import * as XLSX from 'xlsx';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faCancel, faEllipsisVertical, faList, faLocation, faMapLocation, faPenAlt, faPlusMinus, faPlusSquare, faRemove, faRemoveFormat, faSave, faSquareXmark, faXmark, faXmarkSquare } from "@fortawesome/free-solid-svg-icons";
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, FixHeight, FixMobileHeight, FixScreenHeight, funValidateNoInput, getModValue, linksUrl, URIEncrypt } from "../../constants/enum";
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { Box, Drawer } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { calculateTotal, funCheckNumber } from "../../Utility/utility";
import CreateAccount from "../account/CreateAccount";
import { useModalToast } from "../../components/modalToast/ModalToastContext";
import { resetDetail, setNewEntryMode } from "../../state/accountSlice";
import { filter } from "lodash";

const CreateOrderEntry = () => {
    const { compCode, salePerData } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.order)
    const { user } = useSelector((state) => state.auth);
    const [customerData, setCustomerData] = useState([])
    const [deleteItems, setDeleteItems] = useState([])
    const [selectedRowId, setSelectedRowId] = useState(0)
    const [btnAddLabel, setBtnAddLabel] = useState("Add")
    const [selPartyAdd, setSelPartyAdd] = useState("")
    const [selPartyLocation, setSelPartyLocation] = useState("")
    const [selPackSize, setSelPackSize] = useState("")
    const [filterItemData, setfilterItemData] = useState([])
    const [packSizeData, setPackSizeData] = useState([])
    const [openDrawer, setOpenDrawer] = useState(false);
    const [isFinal, setIsFinal] = useState(false);
    const [showOrdNo, setShowOrdNo] = useState("");
    const itemRef = useRef(null);
    const navi = useNavigate();
    const { show } = useModalToast();
    const dispatch = useDispatch();
    const formField = {
        id: "id",
        orderId: "orderId",
        areaId: "areaId",
        partyId: "partyId",
        itemCode: "itemCode",
        itemName: "itemName",
        packSize: "packSize",
        qty: "qty",
        mrp: "mrp",
        amount: "amount",
        netAmount: "netAmount",
        discPer: "discPer",
        discPerQty: "discPerQty",
        discAmt: "discAmt",
        rate: "rate",
        srNo: "srNo",
        closeDate: "closeDate"
    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if ([formField.mrp, formField.id, formField.amount].includes(key))
            acc[key] = 0
        else if (formField.closeDate)
            acc[key] = null
        else acc[key] = ""
        return acc
    }, {})

    const { data: masterData = [], isLoading, } = useFetchWithBody({
        url: apiRoute.saleOrder.masterData,
        queryKey: "fungetmasterDatamap",
        inputData: {
            comp_code: compCode.join(",")
        }

    })
    const { data: partyMaster = [], mutate: funGetParty } = usePost({
        url: apiRoute.saleOrder.getBrokerParty,
        queryKey: "fetchPartyMaster"
    })

    useEffect(() => {
        // if (masterData && Object.keys(masterData).length > 0) {
        //     if (customerData && customerData.length <= 0) {
        //       //  setCustomerData(masterData.acMaster)
        //     }
        // }
        if (partyMaster && partyMaster.length > 0) {
            if (customerData && customerData.length <= 0) {
                setCustomerData(partyMaster)
            }
        }
    }, [partyMaster])

    const { data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.saleOrder.entryDetail,
        queryKey: "fetchModSettingCurrency",
        onSuccessTasks: (data) => {

            if (data && data?.itemDetail?.length > 0) {

                const hasAnyCloseDate = data?.itemDetail?.some(item => item.Close_Date != null);
                setIsFinal(hasAnyCloseDate)


            }
        }

    })

    useEffect(() => {
        //if (salePerData && salePerData.length > 0) {
        funModSetting({
            data: {
                mod_name: ENUM_MOD_NAME.WebApp_Settings
            }
        })
        const isAdmin = user?.isadmin === 1; // strict check

        const BrokerId = isAdmin
            ? null
            : (salePerData?.[0]?.Bac_Id ?? null);

        funGetParty({
            data: {
                comp_code: compCode.join(","),
                br_id: BrokerId,// salePerData[0]?.Bac_Id||''
            }
        })
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { comp_code, bill_type, order_no, bal_qty } = detailParams
            setShowOrdNo(order_no)
            funGetDetail({
                data: {
                    compcode: comp_code,
                    billtype: bill_type,
                    orderno: order_no
                }
            })
            if (bal_qty <= 0)
                setIsFinal(true)
        }
        //  }
    }, [])
    //console.log(detail)


    const { isError: isErrorModSet, data: modSetting = [], mutate: funModSetting } = usePost({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingCurrency",
        onSuccessTasks: (data) => {

            let Item_group = ''
            if (data && data.length > 0) {
                const val = getModValue(ENUM_MOD_PARAMETER.WebApp_Settings.ItemGroup, data)
                Item_group = val.split(",")

            }

            fetchItemMaster({
                data: {
                    itemgroup: Item_group,
                }
            })
        }

    })

    const { mutate: fetchItemRate } = usePostMutateWithSuccess({
        url: apiRoute.saleOrder.getItemRate,
        queryKey: "getItemrate",

    })
    const { data: itemMasterData = [], isPending: isPendingData, mutate: fetchItemMaster } = usePost({
        url: apiRoute.saleOrder.getMasterItem,
        queryKey: "getItemMaster",
        onSuccessTasks: (data) => {
            setfilterItemData(data)
            if (data && data.length > 0) {
                const distinctPackSizes = Object.values(
                    data
                        .filter(item => item.Pack_Size && item.Pack_Size.trim() !== "") // remove blank
                        .reduce((acc, item) => {
                            if (!acc[item.Pack_Size]) {
                                acc[item.Pack_Size] = {
                                    Pack_Size: item.Pack_Size
                                };
                            }
                            return acc;
                        }, {})
                ).sort((a, b) => a.Pack_Size.localeCompare(b.Pack_Size));


                setPackSizeData(distinctPackSizes)
            }
            else
                setPackSizeData([])
        }

    })
    useEffect(() => {
        if (selPackSize && selPackSize != "" && selPackSize != null) {

            const filData = itemMasterData.filter((ele) => ele.Pack_Size == selPackSize)
            setfilterItemData(filData)
        }
        else
            setfilterItemData(itemMasterData)
    }, [selPackSize])

    const itemGridHeadClass = "item-grid-style";
    const [formData, setFormData] = useState({})
    const [rows, setRows] = useState([])
   // console.log(detail)
    const columns = [


        {
            field: formField.id,
            headerName: "Action",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (

                <div className="flex justify-evenly " ><h6 className="px-1 bg-gray-50 rounded-full   font-semibold  text-md" > {row.id}</h6>
                    <strong className="" >
                        <FontAwesomeIcon
                            color="red"
                            className={`  mx-2 cursor-pointer`}
                            onClick={() => handleDeleteRow(row.id, row.closeDate)}
                            icon={faSquareXmark}
                        ></FontAwesomeIcon>

                        <FontAwesomeIcon
                            color="green"
                            className={`cursor-pointer`}
                            onClick={() => handleEditRow(row.id, row.closeDate)}
                            icon={faPenAlt}
                        ></FontAwesomeIcon>


                    </strong>
                </div>

            ),
        },
        {
            field: formField.itemName,
            headerName: "Product",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: "18px",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                    textAlign: "center"
                }} className="text-xs  align-center">
                    {row[formField.itemName] + " - (" + row[formField.packSize] + ")"}

                </div>
            )
        },

        {
            field: formField.qty,
            headerName: "Qty",
            minWidth: 70,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.qty]}

                </div>
            )
        },
        {
            field: formField.mrp,
            headerName: "MRP",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.mrp]}

                </div>
            )
        },
        {
            field: formField.amount,
            headerName: "Amount",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.amount]}

                </div>
            )
        },
        {
            field: formField.discPer,
            headerName: "Disc (%)",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.discPer]} %

                </div>
            )
        },
        {
            field: formField.discAmt,
            headerName: "Disc Amt",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.discAmt]}

                </div>
            )
        },

        {
            field: formField.netAmount,
            headerName: "Net Amount",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.netAmount]}

                </div>
            )
        },

    ]
    const funCalAmount = (name, value) => {
        let t_itemCode = name == formField.itemCode ? value : formData[formField.itemCode]
        const t_qty = name == formField.qty ? value : formData[formField.qty] ?? ""
        let temp = 0
        // const filterData = masterData.itemMaster.filter((ele) => ele.Item_Code == t_itemCode && ele.CompCode == compCode.join(",") && ele.Pac_Id == formData.partyId)
        let t_itemName = formData[formField.itemName]
        let t_packSize = formData[formField.packSize]
        let t_Mrp = formData[formField.mrp]
        let t_Rate = formData[formField.rate]

        if (name == formField.itemCode) {
            const filterData = itemMasterData.filter((ele) => ele.Item_Code == value)

            t_itemName = filterData && filterData.length > 0 ? filterData[0].Item_Desc : ""
            t_packSize = filterData && filterData.length > 0 ? filterData[0].Pack_Size : ""
            //t_packSize = filterData && filterData.length > 0 ? filterData[0].Pack_Size : ""
            fetchItemRate({
                data: {
                    compcode: compCode.join(","),
                    pacid: formData[formField.partyId],
                    itemcode: value
                },
                onSuccess: (data) => {

                    if (data && data.length > 0) {

                        t_Mrp = data[0]?.Rate || 0
                        t_Rate = data[0]?.Rate || 0

                        const t_Disc1 = data[0]?.Disc1 || 0
                        const t_Disc2 = data[0]?.Disc2 || 0
                        const t_Disc3 = data[0]?.Disc3 || 0
                        const t_DiscPer = data[0]?.DiscPer || 0
                        let t_netDesc = 0

                        if (t_DiscPer > 0) {
                            t_netDesc = t_DiscPer
                            t_Rate = t_Rate = (t_Rate * t_DiscPer / 100)
                        }
                        else if (t_Mrp > 0 && (t_Disc1 > 0 || t_Disc2 > 0 || t_Disc3 > 0)) {
                            t_Rate = t_Rate - (t_Rate * t_Disc1 / 100)
                            t_Rate = isFinite(t_Rate) ? t_Rate : 0;
                            t_Rate = t_Rate - (t_Rate * t_Disc2 / 100)
                            t_Rate = isFinite(t_Rate) ? t_Rate : 0;
                            t_Rate = t_Rate - (t_Rate * t_Disc3 / 100)
                            t_Rate = isFinite(t_Rate) ? t_Rate : 0;
                            t_netDesc = ((t_Mrp - t_Rate) / t_Mrp * 100) || 0
                            t_netDesc = isFinite(t_netDesc) ? t_netDesc : 0;

                        }
                        const discPerQty = t_netDesc > 0 && t_Mrp > 0 ? (t_Mrp * t_netDesc / 100) : 0
                        const discAmt = discPerQty * t_qty

                        temp = parseFloat(t_qty) * parseFloat(t_Mrp)
                        const t_amount = funCheckNumber(temp)
                        temp = parseFloat(t_qty) * parseFloat(t_Rate)
                        const t_netamount = funCheckNumber(temp)

                        setFormData({
                            ...formData, [formField.itemCode]: t_itemCode, [formField.packSize]: t_packSize, [formField.itemName]: t_itemName,
                            [formField.qty]: t_qty, [formField.mrp]: t_Mrp, [formField.discPerQty]: discPerQty, [formField.amount]: t_amount.toFixed(2), [formField.discAmt]: discAmt.toFixed(2)
                            , [formField.rate]: t_Rate.toFixed(2), [formField.discPer]: t_netDesc.toFixed(2), [formField.netAmount]: t_netamount.toFixed(2)
                        })
                    }
                    else {
                        setFormData({
                            ...formData, [formField.itemCode]: t_itemCode, [formField.packSize]: t_packSize, [formField.itemName]: t_itemName,
                            [formField.qty]: t_qty, [formField.mrp]: 0, [formField.amount]: 0, [formField.netAmount]: 0, [formField.discAmt]: 0,
                            [formField.discPer]: 0, [formField.rate]: 0, [formField.discPerQty]: 0
                        })
                    }
                }
            })
        }
        else {

            temp = parseFloat(t_qty) * parseFloat(t_Mrp)
            const t_amount = funCheckNumber(temp)

            temp = parseFloat(t_qty) * parseFloat(formData[formField.discPerQty] || 0)
            const t_discAmount = funCheckNumber(temp)

            temp = parseFloat(t_amount) - parseFloat(t_discAmount)
            const t_netamount = funCheckNumber(temp)
            setFormData({
                ...formData,
                [formField.qty]: t_qty, [formField.mrp]: t_Mrp, [formField.amount]: t_amount.toFixed(2),
                [formField.netAmount]: t_netamount.toFixed(2), [formField.discAmt]: t_discAmount.toFixed(2),
            })
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        const valid = funValidateNoInput(value)

        if (valid) {
            //setFormData({ ...formData, [name]: value})
            funCalAmount(name, value)
        }

    }
    const handleAutoCompleteChange = (value, name) => {
        if ([formField.areaId, formField.partyId].includes(name)) {
            if (name == formField.areaId) {
                const filterData = partyMaster.filter((ele) => ele.Add_Area == value)
                setCustomerData(filterData)
            }
            if (name == formField.partyId) {
                const filterAdd = partyMaster.filter((ele) => ele.Party_Id == value)

                if (filterAdd && filterAdd.length > 0) {
                    setSelPartyAdd(filterAdd[0].Party_Address)
                    setSelPartyLocation(filterAdd[0].Location_Link)
                }
            }
            setFormData({ ...formData, [name]: value, })
        }
        else if (name == formField.itemCode) {
            if (formData.partyId != "" && formData.partyId != null) {
                //setFormData({ ...formData, [formField.itemCode]: value })
                funCalAmount(name, value)
            }
            else {
                // toast.error("First Select Customer !", {
                //     position: "top-center",
                //     className: "toast-error"
                // })
                setFormData({ ...formData, [formField.itemCode]: "", [formField.itemName]: "", [formField.packSize]: "", })
                show("First Select Customer !")
            }
        }

    }



    const { data = [], isPending, isError, mutate: funAddUpdate } = usePost({
        url: apiRoute.saleOrder.addUpdate,
        queryKey: "funAddUpdateSaleOrder",
        onSuccessTasks: (data) => {
            if (isNewEntry) {
                if (data && data.length > 0) {
                    // toast.error("Order Submitted", {
                    //     "position": "top-center"
                    // })
                    setFormData({
                        ...formData, [formField.itemCode]: "", [formField.itemName]: "", [formField.packSize]: "", [formField.qty]: "", [formField.mrp]: 0, [formField.amount]: 0
                        , [formField.discAmt]: 0, [formField.discPer]: 0, [formField.discPerQty]: 0, [formField.netAmount]: 0, [formField.rate]: 0
                    })
                    setRows([])
                    show("Order Submitted")
                }
            }
            else {
                navi(linksUrl.salesOrder.orderMaster)
            }

        }

    })

    const totalQty = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "qty",
            }),
        [rows]
    )

    const totalAmount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const totalNetAmount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "netAmount",
            }),
        [rows]
    )
    const totalDiscAmount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmt",
            }),
        [rows]
    )

    useEffect(() => {
        if (!isNewEntry && detail && Object.keys(detail).length > 0) {

            setFormData({
                [formField.partyId]: detail.itemData[0].Pac_Id,
                [formField.areaId]: detail.itemData[0].Party_Area,
                [formField.orderId]: detail.itemData[0].Ord_No,
            })

            if (customerData && customerData.length > 0) {

                //const filterAdd = masterData.acMaster.filter((ele) => ele.Party_Id == detail.itemData[0].Pac_Id)
                const filterAdd = partyMaster.filter((ele) => ele.Party_Id == detail.itemData[0].Pac_Id)
                if (filterAdd && filterAdd.length > 0)
                    setSelPartyAdd(filterAdd[0].Party_Address)
            }


            if (detail && detail?.itemDetail?.length > 0) {
                const rowData = detail.itemDetail.map((item, ind) => {

                    return {
                        id: ind + 1,
                        [formField.srNo]: item?.SrNo,
                        [formField.itemCode]: item?.Item_Code,
                        [formField.itemName]: item?.Item_Desc,
                        [formField.packSize]: item?.Pack_Size,
                        [formField.mrp]: item?.Rate,
                        [formField.qty]: item?.Pcs,
                        [formField.amount]: item?.Amount,
                        [formField.discAmt]: item?.DiscAmt,
                        [formField.discPer]: item?.DiscPer,
                        [formField.discPerQty]: item?.DiscPerQty,
                        [formField.rate]: item?.DiscRate || 0,
                        [formField.netAmount]: item?.NetAmount || 0,
                        [formField.closeDate]: item?.Close_Date || null,
                    }
                })
                setRows(rowData)
            }
        }
    }, [detail, partyMaster,])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isNewEntry && isFinal) {
            if (detail && detail?.itemDetail?.length > 0) {

                const allItemsClosed = detail?.itemDetail?.every(
                    item => item.Close_Date != null
                );
                if (allItemsClosed) {
                    show(<div className=" text-amber-500 font-semibold">Update is not allowed because the order is finalized</div>)
                    return;
                }
            }
        }
        console.log("gfhhf")
        if (rows && rows.length > 0) {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: rows,
                    //area_id: formData[formField.areaId],
                    party_id: formData[formField.partyId],
                    order_date: dayjs(Date()).format("YYYY-MM-DD"),
                    order_no: formData[formField.orderId],
                    bill_type: "S",
                    trade_of: "F",
                    deleteditem_list: deleteItems,
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
        else {
            show("Add Products")

            if (itemRef.current) {
                itemRef.current.focus();
            }
        }
    }
    const handleAddItem = () => {

        if (formData && formData[formField.itemCode] != "" && formData[formField.itemCode] != null && formData.qty > 0) {

            const dupliItem = rows.filter((ele) => ele.itemCode == formData[formField.itemCode])

            if (selectedRowId && selectedRowId != "") {

                const currentDataIndex = rows.findIndex((ele) => ele.id == selectedRowId);
                const t_qty = formData[formField.qty] || 0
                let temp = parseFloat(t_qty) * parseFloat(formData[formField.mrp] || 0)
                const t_amount = funCheckNumber(temp)

                temp = parseFloat(t_qty) * parseFloat(formData[formField.discPerQty] || 0)
                const t_discAmount = funCheckNumber(temp)

                temp = parseFloat(t_amount) - parseFloat(t_discAmount)
                const t_netamount = funCheckNumber(temp)

                const updateData = {
                    ...rows[currentDataIndex], [formField.qty]: t_qty,
                    [formField.amount]: t_amount.toFixed(2), [formField.discAmt]: t_discAmount.toFixed(2)
                    , [formField.netAmount]: t_netamount.toFixed(2)
                }
                const newData = [...rows]
                newData[currentDataIndex] = updateData

                setRows(newData)
                setFormData({
                    ...formData, [formField.itemCode]: "", [formField.itemName]: "", [formField.packSize]: "", [formField.qty]: "", [formField.mrp]: 0, [formField.amount]: 0
                    , [formField.discAmt]: 0, [formField.discPerQty]: 0, [formField.netAmount]: 0, [formField.rate]: 0
                })
                setBtnAddLabel("Add")
                setSelectedRowId("")

            }
            if (dupliItem.length > 0) {
                if (dupliItem[0].id != selectedRowId) {
                    const Index = rows.findIndex((ele) => ele.id == dupliItem[0].id)
                    const updateRow = [...rows]
                    const new_qty = parseFloat(updateRow[Index][formField.qty]) + parseFloat(formData[formField.qty])
                    //console.log(updateRow[Index][formField.amount])
                    //let temp = parseFloat(updateRow[Index][formField.mrp]) * parseFloat(new_qty)
                    const t_qty = updateRow[Index][formField.mrp]
                    let temp = parseFloat(t_qty) * parseFloat(updateRow[Index][formField.mrp] || 0)
                    const t_amount = funCheckNumber(temp)

                    temp = parseFloat(t_qty) * parseFloat(updateRow[Index][formField.discPerQty] || 0)
                    const t_discAmount = funCheckNumber(temp)

                    temp = parseFloat(t_amount) - parseFloat(t_discAmount)
                    const t_netamount = funCheckNumber(temp)

                    updateRow[Index][formField.qty] = new_qty
                    updateRow[Index][formField.amount] = t_amount.toFixed(2)
                    updateRow[Index][formField.discAmt] = t_discAmount.toFixed(2)
                    updateRow[Index][formField.netAmount] = t_netamount.toFixed(2)

                    setRows(updateRow)
                    setFormData({
                        ...formData, [formField.itemCode]: "", [formField.itemName]: "", [formField.packSize]: "", [formField.qty]: "", [formField.mrp]: 0, [formField.amount]: 0
                        , [formField.discAmt]: 0, [formField.discPerQty]: 0, [formField.netAmount]: 0, [formField.rate]: 0, [formField.discPer]: 0
                    })
                }
            }
            else {
                if (!isFinal) {
                    const newRow = { ...formData, id: (rows.length) + 1, [formField.srNo]: 0, }
                    setRows([...rows, newRow])
                    setFormData({
                        ...formData, [formField.itemCode]: "", [formField.itemName]: "", [formField.packSize]: "", [formField.qty]: "", [formField.mrp]: 0, [formField.amount]: 0
                        , [formField.discAmt]: 0, [formField.discPerQty]: 0, [formField.netAmount]: 0, [formField.rate]: 0, [formField.discPer]: 0
                    })
                }
                else {
                    show("new Item can not be add as bill already generated")
                }

            }
            setSelectedRowId("")

        }
        else {
            show("Select Product and Quantity")
            //     toast.error("Select Product and Quantity", {
            //         "position": "top-center",
            //         className: "toast-error"
            //     })
        }
        if (itemRef.current) {
            itemRef.current.focus();
        }


    }
    const handleDeleteRow = (id, closeDate) => {
        if (closeDate == null) {

            const updatedRows = rows.filter(row => row.id !== id);
            //  setRows(updated);
            const deleteRow = rows.filter((row) => row.id == id)
            //console.log(deleteRow)
            const rearrangedRows = updatedRows.map((row, index) => {
                return {
                    ...row,
                    id: index + 1, // Reassign IDs to start from 1 again
                }
            })

            setRows(rearrangedRows)
            setDeleteItems([...deleteItems, ...deleteRow])
        }
        else {
            show("Item Can not be delete as it lock")
        }
    }

    const handleEditRow = (id, closeDate) => {
        console.log(id, closeDate)
        if (closeDate == null) {

            const editRow = rows.filter((row) => row.id == id)
            setFormData({
                ...formData, [formField.itemCode]: editRow[0].itemCode,
                [formField.qty]: editRow[0].qty,
                [formField.mrp]: editRow[0].mrp,
                [formField.discPerQty]: editRow[0].discPerQty,
                [formField.rate]: editRow[0].rate,
                [formField.discPer]: editRow[0].discPer,


            })
            setSelectedRowId(id)

            setBtnAddLabel("Update")
        }
        else {
            show("Item Can not be edit as it lock")
        }
    }

    const handleReset = () => {
        navi(linksUrl.salesOrder.orderMaster)
        //setFormData({ ...formData, [formField.areaId]: "", [formField.partyId]: "", [formField.itemCode]: "", [formField.itemName]: "", [formField.qty]: 0, [formField.mrp]: 0, [formField.amount]: 0 })
        // setRows([])
        // setSelectedRowId("")
    }

    const handleClear = () => {
        setSelectedRowId("")
        setSelPackSize("")
        setFormData({
            ...formData, [formField.itemCode]: "", [formField.itemName]: "", [formField.packSize]: "", [formField.qty]: 0, [formField.mrp]: 0, [formField.amount]: 0
            , [formField.discAmt]: 0, [formField.discPer]: 0, [formField.discPerQty]: 0, [formField.netAmount]: 0, [formField.rate]: 0
        })
    }

    if (isError) {
        {
            show("Some thing Went wrong !")
            // if (!toast.isActive("toatError")) {
            //     toast.error("Some thing Went wrong !", {
            //         "position": "top-center",
            //         className: "error-toast",
            //         toastId: "toatError"
            //     })
            // }
        }
    }

    const handleAddNewAccount = () => {
        dispatch(resetDetail())
        navi(linksUrl.master.account.createAccountMaster)

    }
    const handleClickPrev = () => {
        navi(linksUrl.salesOrder.orderMaster)
    }
    if (isPending) {
        return <LoadingCard />
    }
    const lat = 40.7128
    const lng = -74.0060
    return (
        <MainContainer pageName={!isNewEntry ? `Update Order (${showOrdNo})` : "New Order"}
            breadcrumbs={["Sale Order", `${!isNewEntry ? `Update Order (${showOrdNo})` : "New Order"}`]}
            prevPage={{
                show: true,
                onClick: handleClickPrev,
            }} >
            <div className="">

            </div>
            <Card>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <CardBody className=" py-5" style={{ height: isMobile ? FixMobileHeight : FixScreenHeight }}>
                        {isFinal ? <h2 className={`text-red-500  bg-red-50 p-1`}>{isFinal ? "Changes cannot be made as the bill has already been generated." : "-"}</h2> : ""}

                        <div className="flex gap-4 align-top justify-between items-baseline mb-2">
                            {!isNewEntry ? <h2 className={` text-slate-700 text-md font-bold p-1`}>{showOrdNo}</h2> : "-"}
                            <Button size="sm" variant="shadow"
                                className="text-white"
                                color="warning" onPress={handleAddNewAccount}>Add New Account</Button>
                        </div>
                        {/* <Drawer open={openDrawer} anchor="top"  >
                            <CreateAccount/>
                        </Drawer> */}


                        <div className="flex gap-4 align-top items-baseline mb-2">
                            <Autocomplete
                                size="md"
                                name={formField.areaId}
                                label={"Area"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={""}
                                menuTrigger="input"
                                isLoading={isLoading}
                                color="warning"
                                className="max-w-23 font-semibold "
                                classNames={{
                                    label: "font-semibold ",
                                }}
                                variant="light"
                                isClearable={false}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    masterData && masterData.areaMaster ? masterData.areaMaster : []
                                }
                                onSelectionChange={(e) => handleAutoCompleteChange(e, formField.areaId)}
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={formData[formField.areaId]}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.Add_Area}
                                    >
                                        {list.Add_Area}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                        </div>
                        <div className="flex gap-4 align-top items-center mb-2">
                            <Autocomplete
                                size="md"
                                name={formField.partyId}
                                label={"Customer"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={""}
                                radius="sm"
                                isRequired
                                isLoading={isLoading}
                                menuTrigger="input"
                                color="primary"
                                variant="light"
                                className="max-w-23  font-semibold"
                                classNames={{
                                    label: "font-semibold ",
                                    // listbox: "border-1 border-gray-400 bg-gray-50  rounded-full",
                                }}
                                isClearable={false}
                                isVirtualized
                                isReadOnly={!isNewEntry ? true : false}
                                defaultItems={
                                    customerData && customerData.length > 0 ? customerData : []

                                }
                                onSelectionChange={(e) => handleAutoCompleteChange(e, formField.partyId)}
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={formData[formField.partyId]}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.Party_Id}
                                    >
                                        {list.Party_Name}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                        </div>
                        {
                            formData && formData.partyId != "" && formData.partyId != null ?
                                <>
                                    {setSelPartyLocation && selPartyLocation != "" ?
                                        <div className="flex justify-end my-2">
                                            <Button variant="shadow" size="sm"
                                                className="bg-yellow-500 text-white p-2 font-semibold "
                                                startContent={<FontAwesomeIcon className="text-xl font-semibold" icon={faLocation}></FontAwesomeIcon>}
                                                onPress={() =>
                                                    window.open(
                                                        `${selPartyLocation}`,
                                                        "_blank"
                                                    )

                                                }
                                            >
                                                View Location
                                            </Button></div> : ""
                                    }
                                    {selPartyAdd && selPartyAdd != "" ? <div className="bg-green-100 p-2 rounded-md text-xs uppercase font-semibold">
                                        <h2 className="text-xs font-bold  text-green-700 mb-1" >CUSTOMER ADDRESS</h2>
                                        <div style={{ fontSize: "0.7rem" }} >{selPartyAdd}</div>
                                    </div> : ""}

                                    <div className={`border-0 bg-graay-50  my-2 ${isMobile ? "p-2" : "p-5"}  rounded-md border-red-200 border-1 `}>
                                        {/* <Chip className="text-white bg-slate-600 "  variant="solid" ><FontAwesomeIcon className="px-5" icon={faArrowCircleRight} ></FontAwesomeIcon> Add Products</Chip> */}
                                        <div className={`${isMobile ? "flex-wrap" : ""} items-center flex gap-5`}>
                                            <Autocomplete
                                                size="md"
                                                ref={itemRef}
                                                name={"packSize"}
                                                label={"Pack Size"}
                                                eventResizeFeature={true}
                                                selectionMode="single"
                                                showScrollIndicators={true}
                                                labelPlacement={"outside"}
                                                placeholder={" "}
                                                radius="sm"
                                                menuTrigger="input"
                                                isLoading={isPendingData}
                                                isDisabled={selectedRowId && selectedRowId != "" && selectedRowId > 0 ? true : false}
                                                color="danger"
                                                variant="bordered"
                                                className={` ${isMobile ? "w-full" : "max-w-32"}  text-xs font-semibold`}
                                                classNames={{
                                                    base: " text-xs",

                                                }}
                                                // popoverProps={{
                                                //     placement: "bottom",
                                                //     shouldFlip: false,
                                                //     offset: 6,
                                                // }}

                                                // listboxProps={{
                                                //     style: {
                                                //         maxHeight: "400px",
                                                //         overflowY: "auto",
                                                //     },
                                                // }}
                                                isClearable={true}
                                                isVirtualized
                                                // readonly={isNewEntry ? false : true}
                                                defaultItems={
                                                    packSizeData ? packSizeData : []
                                                }
                                                onSelectionChange={setSelPackSize}
                                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                //onChange={handleFormSelectionChange}
                                                selectedKey={selPackSize}
                                            >
                                                {(list) => (
                                                    <AutocompleteItem
                                                        key={list.Pack_Size}
                                                    >
                                                        {list.Pack_Size}
                                                    </AutocompleteItem>
                                                )}
                                            </Autocomplete>
                                            <Autocomplete
                                                size="md"
                                                ref={itemRef}
                                                name={formField.itemCode}
                                                label={"Product"}
                                                eventResizeFeature={true}
                                                selectionMode="single"
                                                showScrollIndicators={true}
                                                labelPlacement={"outside"}
                                                placeholder={" "}
                                                radius="sm"
                                                menuTrigger="input"
                                                isLoading={isPendingData}
                                                isDisabled={selectedRowId && selectedRowId != "" && selectedRowId > 0 ? true : false}
                                                color="danger"
                                                variant="bordered"
                                                popoverProps={{
                                                    placement: "bottom",
                                                    shouldFlip: false,
                                                    offset: 6,
                                                }}

                                                listboxProps={{
                                                    style: {
                                                        maxHeight: "200px",
                                                        overflowY: "auto",
                                                    },
                                                }}
                                                className={` ${isMobile ? "w-full" : "max-w-80"}  text-xs font-semibold`}
                                                classNames={{
                                                    base: " text-xs",

                                                }}
                                                isClearable={false}
                                                isVirtualized
                                                // readonly={isNewEntry ? false : true}
                                                defaultItems={
                                                    filterItemData ? filterItemData : []
                                                }
                                                onSelectionChange={(e) => handleAutoCompleteChange(e, formField.itemCode)}
                                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                //onChange={handleFormSelectionChange}
                                                selectedKey={formData[formField.itemCode]}
                                            >
                                                {(list) => (
                                                    <AutocompleteItem
                                                        key={list.Item_Code}
                                                        classNames={{
                                                            base: "min-h-[24px] py-1",
                                                            title: "text-xs whitespace-normal break-words",
                                                        }}
                                                    >
                                                        {`(${list.Item_Code})${list.Item_Desc} ${list.Pack_Size != "" ? `-[${list.Pack_Size}]` : ""} `}
                                                    </AutocompleteItem>
                                                )}
                                            </Autocomplete>

                                            <Input
                                                type="text"
                                                label="Quantity"
                                                placeholder=" "
                                                size="md"
                                                labelPlacement="outside"
                                                name={formField.qty}
                                                value={formData[formField.qty]}
                                                color="danger"
                                                variant="bordered"
                                                onChange={handleInputChange}
                                                className={`${isMobile ? "w-full" : "max-w-24"}`}
                                                classNames={{
                                                    // inputWrapper: " border-0 border-gray-400 bg-gray-50 ",
                                                    label: " font-semibold text-sm",

                                                }}
                                            />
                                            <div className={`${isMobile ? "flex-nowrap justify-center" : ""} w-full   items-center flex gap-5`}>
                                                <Chip
                                                    radius="sm"
                                                    color="primary"
                                                    size="md"
                                                    variant="light"
                                                    // isDisabled={isFinal ? true : false}
                                                    className={`${isMobile ? "w-5/12" : "max-w-40"}   cursor-default bg-slate-600 p-5  mt-0 md:mt-4 sm:mt-4 sm:p-4  md:p-4
                                                     text-md  md:text-sm sm:text-sm  text-white`}
                                                    onClick={handleAddItem}
                                                    startContent={<FontAwesomeIcon className="text-md mr-1" icon={faPlusSquare} />}
                                                >
                                                    {btnAddLabel} Product
                                                </Chip>
                                                <Chip
                                                    radius="sm"
                                                    color="warning"
                                                    size="md"
                                                    variant="solid"
                                                    className={`${isMobile ? "w-5/12" : "max-w-40"} cursor-default mt-0 md:mt-4 sm:mt-4 p-5  sm:p-2  md:p-2 text-md 
                                                     md:text-sm sm:text-sm  bg-red-400 text-white`}
                                                    onClick={handleClear}
                                                    startContent={<FontAwesomeIcon className="text-md mr-1" icon={faXmarkSquare} />}
                                                >
                                                    Reset
                                                </Chip>
                                            </div>
                                        </div>

                                        <div className="my-5">
                                            <Chip className="bg-red-100  border-1 border-red-200 mb-2 text-xs font-bold"><strong>Total Products :{rows.length}</strong></Chip>
                                            {rows && rows.length > 0 ?
                                                <div>
                                                    <Box sx={{ height: rows.length > 10 ? 410 : "auto", width: '100%' }}>
                                                        <DataGrid
                                                            rows={rows}
                                                            columns={columns}
                                                            editMode="row"
                                                            columnHeaderHeight={30}
                                                            rowHeight={isMobile ? 50 : 40}
                                                            disableColumnSorting={true}
                                                            disableColumnMenu={true}
                                                            getRowClassName={(params) => {
                                                                if (params.id == selectedRowId)
                                                                    return 'select-row'
                                                                return 'row-class';
                                                            }}
                                                            // getRowClassName={getRowClassName}
                                                            sx={{
                                                                '& .MuiDataGrid-columnHeaders': {
                                                                    position: 'sticky',
                                                                    top: 0,
                                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                                },
                                                                '& .MuiDataGrid-columnHeaderTitle': {
                                                                    fontWeight: 'bold',
                                                                },
                                                                '& .select-row': {
                                                                    backgroundColor: "#ebe8e8",

                                                                },
                                                                '& .row-class': {
                                                                    fontSize: "0.9rem",

                                                                },
                                                                '& .sticky-row': {
                                                                    position: 'sticky',
                                                                    bottom: 0,
                                                                    color: "#FFFFFF",
                                                                    backgroundColor: '#424242f5',
                                                                    zIndex: 10,
                                                                },
                                                                '& .sticky-row:hover': {
                                                                    backgroundColor: "#424242f5"
                                                                },
                                                                '& .MuiDataGrid-footerContainer': {
                                                                    backgroundColor: "#f1f1f1ff"
                                                                }
                                                            }}
                                                        />
                                                    </Box>


                                                    <div className="flex flex-wrap sm:flex-nowrap md:flex-nowrap justify-end  gap-2 my-3 justify-end">
                                                        <div className="flex flex-nowrap w-full sm:w-auto md:w-auto gap-5 items-center">
                                                            <div
                                                                className="
      
      w-full md:w-auto
      bg-green-100 text-green-800
      border border-green-500
      rounded-lg
      py-1 px-1
      text-center
    "
                                                            >
                                                                <div className="text-[11px] sm:text-xs font-medium uppercase">
                                                                    Quantity
                                                                </div>

                                                                <div className="text-sm sm:text-md font-bold truncate">
                                                                    {totalQty}
                                                                </div>
                                                            </div>

                                                            <div
                                                                className="
      
      w-full md:w-auto
      bg-blue-100 text-blue-700
      border border-blue-500
      rounded-lg
      py-1 px-1
      text-center
    "
                                                            >
                                                                <div className="text-[11px] sm:text-xs font-medium uppercase">
                                                                    Amount
                                                                </div>

                                                                <div className="text-sm sm:text-md font-bold truncate">
                                                                    {totalAmount}
                                                                </div>
                                                            </div>
                                                        </div><div className="flex flex-nowrap w-full sm:w-auto md:w-auto  gap-5 items-center">
                                                            <div
                                                                className="
      
      w-full md:w-auto
      bg-yellow-100 text-yellow-700
      border border-yellow-500
      rounded-lg
      py-1 px-1
      text-center
    "
                                                            >
                                                                <div className="text-[11px] sm:text-xs font-medium uppercase">
                                                                    Disc Amount
                                                                </div>

                                                                <div className="text-sm sm:text-md font-bold truncate">
                                                                    {totalDiscAmount}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="
      
      w-full md:w-auto
      bg-red-100 text-red-700
      border border-red-500
      rounded-lg
      py-1 px-1
      text-center
    "
                                                            >
                                                                <div className="text-[11px] sm:text-xs font-medium uppercase">
                                                                    Net Amount
                                                                </div>

                                                                <div className="text-sm sm:text-md font-bold truncate">
                                                                    {totalNetAmount}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : ""}
                                            {/* <Chip radius="sm" variant="solid" size="md" className="w-2/5 bg-green-200 text-green-800  border-1 border-green-500 text-sm font-bold"><strong> {totalQty}</strong></Chip>
                                                <Chip radius="sm" variant="solid" className="w-2/5 bg-blue-100 text-blue-700  border-1 border-blue-500 text-sm font-bold"><strong>  {totalAmount}</strong></Chip>
                                                <Chip radius="sm" variant="solid" className="w-full bg-red-100 text-red-700  border-1 border-red-500 text-sm font-bold"><strong>  {totalNetAmount}</strong></Chip> */}
                                            {/* </div> */}
                                        </div>
                                        <div className="flex  justify-center gap-4 align-top items-center mb-2">
                                            <Button
                                                color="primary"
                                                type="submit"
                                                size="md"
                                                variant="shadow"
                                                isLoading={isPending}
                                                isDisabled={user?.isadmin == 1 ? true : false}
                                                className="bg-slate-700 text-white text-sm"
                                                startContent={<FontAwesomeIcon icon={faSave} />}
                                            >
                                                {!isNewEntry ? "Update" : "Save"}
                                            </Button>
                                            <Button
                                                color="danger"
                                                size="md"
                                                variant="shadow"
                                                isLoading={isPending}
                                                className="text-sm"
                                                onPress={handleReset}
                                                startContent={<FontAwesomeIcon icon={faCancel} />}
                                            >
                                                Cancle
                                            </Button>
                                        </div>
                                    </div>
                                </>
                                : ""}
                    </CardBody>
                </form>
            </Card>
        </MainContainer>
    )
}
export default CreateOrderEntry